export const formatStoryteller = (storyteller?: string) => {
  if (!storyteller) return { name: '', org: '' };
  const [name, ...rest] = storyteller.split('|').map(s => s.trim());
  return { name, org: rest.join(' | ') };
};
